import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { createPostOrder } from "../services/ecomSalesOrders.service";
import { HttpStatus } from "modules/core";
import notistack from "modules/core/notistack";

interface CreateShipmentModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedItems: any[];
    selectedId: number | undefined;
}

interface ShipmentForm {
    Pickup_Time: string;
    PickUpEmailId: string;
}

const CreateShipmentModal: React.FC<CreateShipmentModalProps> = ({
    isOpen,
    onClose,
    selectedItems,
    selectedId
}) => {

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm<ShipmentForm>();

    const onSubmit = async (data: ShipmentForm) => {
        const payload = {
            ...data,
            SalesOrderItrmId: selectedItems
                .map(item => item?.id)
                .filter((id): id is number => id !== undefined),
            SalesOrderId: selectedId
        };

        try {
            const response = await createPostOrder(payload)
            if (response.status === HttpStatus.Success) {
                notistack.notifyFromApi(response)
                reset()
                onClose()
            } else {
                notistack.notifyFromApi(response)
            }
        } catch (error: any) {
            notistack.error(error)
        }
    };

    return (
        <Modal
            show={isOpen}
            onHide={() => {
                reset()
                onClose()
            }}
            centered
            backdrop="static"
            keyboard={false}
            style={{
                background: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Create Shipment</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-3">
                        <Form.Label>Pickup Time <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="datetime-local"
                            {...register("Pickup_Time", {
                                required: "Pickup time is required",
                            })}
                            className={errors.Pickup_Time ? "is-invalid form-control-sm" : "form-control-sm"}
                        />
                        <div className="invalid-feedback">
                            {errors.Pickup_Time?.message}
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Pickup Email <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            {...register("PickUpEmailId", {
                                required: "Email is required",
                                pattern: {
                                    value: /^\S+@\S+$/i,
                                    message: "Invalid email",
                                },
                            })}
                            className={errors.PickUpEmailId ? "is-invalid form-control-sm" : "form-control-sm"}
                        />
                        <div className="invalid-feedback">
                            {errors.PickUpEmailId?.message}
                        </div>
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-2">
                        <Button className="add-btn btn" onClick={() => {
                            reset()
                            onClose()
                        }}>
                            Cancel
                        </Button>
                        <Button className="btn submit-btn" type="submit" disabled={isSubmitting}>
                            Submit
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateShipmentModal;